import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import { Container, Menu, Dropdown, Button, Label } from "semantic-ui-react";
import { Auth } from "aws-amplify";
import UserContext from "contexts/UserContext";
import logoIconImg from "../logo-kmd-icon.svg";
import logoTextImg from "../logo-kmd-text.svg";
import UserAvatar from "components/UserAvatar";
import FeedbackButton from "components/FeedbackButton";

const AppHeader = withRouter(({ history }) => {
  const appUser = useContext(UserContext);
  const userAttributes = appUser.getAttributes();

  const [userName, setUserName] = useState(
    userAttributes.name || userAttributes.email
  );

  appUser.onAttributesChange = (attrs) => {
    setUserName(attrs.name || attrs.email);
  };

  return (
    <Menu fixed="top" size="tiny" inverted id="app-header">
      <Container>
        <Menu.Item as="a" onClick={() => history.push("/")}>
          <img id="logo-icon" alt="Know My Day" src={logoIconImg} />
          <img
            id="logo-text"
            className="mobile-hidden"
            alt="Know My Day"
            src={logoTextImg}
          />
        </Menu.Item>
        <Menu.Menu position="right">
          {!appUser.isPro() && appUser.isTeacher ? (
            <Menu.Item className="mobile-hidden" position="right">
              <Button color="teal" onClick={() => history.push("/upgrade")}>
                Upgrade to Pro for Free
              </Button>
            </Menu.Item>
          ) : null}
          <Menu.Item position="right" className="mobile-hidden">
            <FeedbackButton />
          </Menu.Item>
          <Dropdown
            item
            trigger={
              <span>
                <UserAvatar name={userName} /> {userName}
                {appUser.isPro() ? (
                  <Label
                    style={{ marginLeft: "0.5em" }}
                    size="mini"
                    color="blue"
                  >
                    PRO
                  </Label>
                ) : null}
              </span>
            }
          >
            <Dropdown.Menu>
              <Dropdown.Item
                icon="setting"
                text="My Settings"
                onClick={() => history.push("/settings")}
              />
              {appUser.isAdministrator ? (
                <Dropdown.Item onClick={() => history.push("/admin")}>
                  Administration Home
                </Dropdown.Item>
              ) : null}
              <FeedbackButton inDropdown />
              {!appUser.isPro() && appUser.isTeacher ? (
                <Dropdown.Item
                  className="desktop-hidden"
                  onClick={() => history.push("/upgrade")}
                >
                  <span className="ui basic teal label">Upgrade to Pro</span>
                </Dropdown.Item>
              ) : null}
              <Dropdown.Divider />
              <Dropdown.Item
                icon="log out"
                text="Log Out"
                onClick={() => {
                  return Auth.signOut().then(() => (window.location = "/"));
                }}
              />
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Menu>
      </Container>
    </Menu>
  );
});

export default AppHeader;
